import CurrentYear from "./CurrentYear";
import { NavLink } from "react-router-dom";

export default function Footer(props) {
    const copyright = props.props.footerData.copyright

    return (
        <div className="Footer">
            <p className="Footer-Text">
                © {copyright} <CurrentYear />
            </p>
            <NavLink className="Footer-Text" to="/terms">
                Terms and Conditions
            </NavLink>
            <NavLink className="Footer-Text" to="/privacy">
                Privacy Policy
            </NavLink>
            <NavLink className="Footer-Text" to="/support">
                Contact
            </NavLink>
        </div>
    );
}
